import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { paths } from 'config/path_helpers';

import { SchoolProfile, SchoolProfileCategory } from '@schools/app/types';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  category: SchoolProfileCategory;
  profiles: SchoolProfile[];
  preview: boolean;
}

const ProfileCardSet: React.FC<Props> = (props) => {
  return (
    <div className={cx(style.cardSetContainer, 'd-flex flex-row flex-wrap')}>
      {
        props.profiles.map((profile, idx) => (
          <ProfileCard
            key={idx}
            category={props.category}
            preview={props.preview}
            profile={profile}
          />
        ))
      }
    </div>
  );
};

interface ProfileCardProps {
  category: SchoolProfileCategory;
  preview: boolean;
  profile: SchoolProfile;
}

const ProfileCard: React.FC<ProfileCardProps> = (props) => {
  const aspectRatio = 3/2;
  const coverPhoto = props.profile.coverPhotos[0];

  return (
    <div className={cx(style.card, 'd-flex flex-column')} style={{ backgroundColor: colors.grayLightest, borderRadius: 10, position: 'relative' }}>
      <Link
        to={paths.admissions.schoolProfile(props.profile.slug, props.category.slug, props.preview)}
      >
        <div style={{ padding: 20 }}>
          <div
            style={{
              backgroundColor: colors.grayLightest,
              borderRadius: 10,
              overflow: 'hidden',
              paddingTop: `${(1/aspectRatio) * 100}%`,
              position: 'relative',
              width: '100%'
            }}
          >
            <img
              alt={coverPhoto.title}
              src={`${coverPhoto.url}?fit=fill&h=217&w=326`}
              style={{ height: 'auto', position: 'absolute', top: 0, width: '100%' }}
            />
          </div>

          <img
            alt={`${props.profile.name} Logo`}
            className={style.logo}
            src={`${props.profile.logo}?fit=fill&h=192&w=192`}
          />

          <h4><strong>{props.profile.name}</strong></h4>

          <div className="d-flex flex-column" style={{ gap: 10 }}>
            {
              (props.profile.programAttributes || []).map((attribute, idx) => (
                <div key={idx} className="align-items-center d-flex small">
                  <FontAwesomeIcon icon={attribute.icon} style={{ textAlign: 'center', width: 25 }} />

                  <div>{attribute.value}</div>
                </div>
              ))
            }
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProfileCardSet;
